import React from 'react';
import { IExportPlugin, PluginType } from '@/version-types';
import { CropStagePlugin } from './controller';
import { StageCropHistory } from './history';
import cropStagePluginState from './models/crop-stage-state';
import { CropStagePluginView } from './views';

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 3,
    name: 'crop-stage',

    render() {
        return <CropStagePluginView />;
    },

    createHistory({ identity }) {
        return [new StageCropHistory(identity)];
    },

    createInstance({ identity }) {
        return [{ key: 'CropStagePlugin', value: new CropStagePlugin(identity) }];
    },

    createState() {
        return [cropStagePluginState];
    },
};

export default exportPlugin;
